import {Component, OnChanges, OnInit, SimpleChanges, ViewChild, ɵConsole} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {LoadingService} from '../../services/loading/loading.service';
import {MasterdataAdminService} from 'src/app/services/masterdata-admin/masterdata-admin.service';
import {AlertService} from '../../services/alert/alert.service';
import {Router} from '@angular/router';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import AppConstants, {
  ControKeysControltype as CKCT,
  FreightRateType as RT,
  MasterDataAdminType as MDT,
  ShipmentType as ST,
  BusinessType as BT
} from '../../shared/common-components/AppConstants';
import {ControlKeys} from '../ratefile-open/control-keys';
import {
  Carrier,
  CarrierRfsps,
  RatesSroMaster,
  FrtDieselPrice,
  AgencyMaster,
  FrtRatesZone,
  StateCountry,
  HhgIcc,
  HhgCustomerSatisfactionIndex
} from 'src/app/shared/common-components/common-structure';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {AgencyMasterService} from '../../services/agency-master/agency-master.service';
import {CustomerRegistrationService} from '../../services/customer-registration/customer-registration.service';
import {RatesSroMasterService} from 'src/app/services/rates-sro-master/rates-sro-master.service';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';
import {MasterDataAdminCountryAuditTrailComponent} from '../masterdata-admin-country-audit-trail/masterdata-admin-country-audit-trail.component';
import { UserService } from 'src/app/services/user/user.service';
import {CarrierService} from "../../services/carrier/carrier.service";
import {commaSeparatedEmailsValidator} from "../frt-rate-edit/Validators";
import {DownloadAnchorTagComponent} from "../download/download-file.component";
import {takeWhile} from "rxjs/operators";

@Component({
    selector: 'app-masterdata-admin',
    templateUrl: './masterdata-admin.component.html',
    styleUrls: ['./masterdata-admin.component.css'],
    standalone: false
})

export class MasterDataAdminComponent implements OnInit, OnChanges {

  constructor(private fb: UntypedFormBuilder, public loader: LoadingService,
              private modalService: BsModalService,
              private masterdataAdminService: MasterdataAdminService,
              private alertService: AlertService, private router: Router,
              private agencyMasterService: AgencyMasterService,
              private customerRegistrationService: CustomerRegistrationService,
              private ratesSroMasterService: RatesSroMasterService,
              private stateCountryService: StateCountryService,
              private userService: UserService,
              private carrierService: CarrierService,
              private shipmentAuditTrailService: ShipmentAuditTrailService) {
    this.tmssLoader = this.loader;
    this.domLayout = 'autoHeight';
    this.paginationPageSize = 10;
  }

  gridOptionsApi: any;
  masterDataAdminForm: UntypedFormGroup;
  coreTspForm: UntypedFormGroup;
  isCoreTspEdit: boolean;
  selectedCoreTsp: any;
  isCreate: boolean;
  isSelected: boolean;
  countryCode: string;
  stateCountryEntity: StateCountry;
  stateCountry: any;
  serviceAreaId: any;
  isCountryUsa: Boolean = true;
  private tmssLoader;
  stateCountryType: string;
  county: any;
  iccId: number;
  gsaServiceAreaId: number;
  countyName: string;
  city: string;
  state: string;
  stateAbbreviation: string;
  countyCode: string;
  countryList: StateCountry[];
  hhgIcc: any;
  hhgIccEntity: HhgIcc;
  masterDataAdminTypes: any = [];
  hhgAndFrtSelection = [MDT.COUNTRY, MDT.COUNTY, MDT.SERVICEAREA, MDT.FREIGHTSERVICESMASTER, MDT.CARRIERRFSPS, MDT.CONTROLKEYS, MDT.DIESELPRICE, MDT.ZONES,
     MDT.CUSTOMERSATISFACTIONINDEX, MDT.CORETSPINDENTIFICATION];

  hhgSelection = [MDT.COUNTRY, MDT.COUNTY, MDT.CONTROLKEYS, MDT.SERVICEAREA, MDT.CARRIERRFSPS, MDT.CUSTOMERSATISFACTIONINDEX, MDT.CORETSPINDENTIFICATION];
  frtSelection = [MDT.COUNTRY, MDT.COUNTY, MDT.CONTROLKEYS, MDT.FREIGHTSERVICESMASTER, MDT.ZONES, MDT.DIESELPRICE];
  showCountryFields: boolean;
  showCountyFields: boolean;
  showServiceAreaFields: boolean;
  showFreightServicesMasterFields: boolean;
  showCarrierRfsps: boolean;
  showControlKeys: boolean;
  showCoreTsp: boolean;
  retrieveSuccess: boolean;
  saveSuccess: boolean;
  retieveErrorMessage: any;
  saveSuccessMessage: any;
  saveErrorMessage: any;
  ratePeriodDetails: ControlKeys[];
  freightRateTypes = [RT.LTL, RT.TL];
  sroIdList: RatesSroMaster[];
  rateTypeId: number;
  showltl: boolean;
  showtl: boolean;
  ltlMaximumPct: any;
  ltlMinimumPct: any;
  tlMaximumPct: any;
  tlMinimumPct: any;
  showTable: boolean;
  headerElements = [];
  controlKey: ControlKeys;
  freightServicesMaster: any;
  paginationPageSize;
  domLayout;
  frtRatePeriodDetails = [];
  rateTypeLtl: boolean;
  columnDefs: any;
  hhgCsiId: number;
  carrierId: number;
  saveDupError: boolean;
  shipmentsList: any[];
  carrierList: any[];
  modalRef?: BsModalRef;
  @ViewChild("createModal", { static: true })
  public createModal: ModalDirective;
  selectedCarrierRfsp: any;
  freightListLtlColumnDefs = [
    {headerName: 'Effective Date', field: 'effectiveDate'},
    {headerName: 'Expiry Date', field: 'expiryDate'},
    {headerName: 'SRO Master ID', field: 'sroMasterId'},
    {headerName: 'Service Level', field: 'serviceLevel'},
    {headerName: 'LTL Minimum Charge %', field: 'ltlMaximumChargePct'},
    {headerName: 'LTL Maximum Charge %', field: 'ltlMinimumChargePct'},
  ];

  freightListTlColumnDefs = [
    {headerName: 'Effective Date', field: 'effectiveDate'},
    {headerName: 'Expiry Date', field: 'expiryDate'},
    {headerName: 'SRO Master ID', field: 'sroMasterId'},
    {headerName: 'Service Level', field: 'serviceLevel'},
    {headerName: 'TL Minimum Charge %', field: 'tlMinimumCharge'},
    {headerName: 'TL Maximum Charge %', field: 'tlMaximumCharge'}
  ];

  rfspResultsGridOptions: GridOptions = this.initializeGridOptions();

  datePickerConfig: Partial<BsDatepickerConfig>;
  private gridApi;
  controlTypes: any;
  ct: string;
  carrierRfsps: Carrier[];
  carrierIdRfsps: any;
  carrierRFSPType: Carrier;
  newCarrier: Carrier;
  newControlKey: ControlKeys;
  crfsps: string;
  showRfspsTable: boolean;
  carrierRfspsDetails = [];
  allCarrierRfsps = [];
  carrierRfspsEntity: CarrierRfsps;
  scacCodeList: string[] = [];
  typeaheadlist: string[];
  carrierTspSearchList: Carrier[];
  carrierRfspColumnDefs = [
    {headerName: 'RFSP SCAC Code', field: 'rfspScac'},
    {
      headerName: 'TSP SCAC Code', field: 'tspScac',
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.tspScac + '</a>',
      onCellClicked: event => this.onCarrierRfspSelected(event.data)
    },
    {headerName: 'Type', field: 'shipmentType'},
  ];

  coreTspColumnDefs = [
    {
      headerName: 'Delete',
      checkboxSelection: true,
      width: 40
    },
    {headerName: 'Agency Group', field: 'agencyGroup',
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.agencyGroup + '</a>',
      onCellClicked: event => this.openCoreTspModal('edit', event.data)
    },
    {
      headerName: 'Core TSP SCAC', field: 'agencyTsp',
    },
    {headerName: 'Agency Emails', field: 'agencyEmails'},
  ];
  agencyCoreTsps = [];

  shipmentTypes = [ST.IFF, ST.RATEFILING, ST.THIRTYEIGHTY];
  controlKeysControlTypes:any = [];
  hhgAndFrtControlTypes = [CKCT.HHGPCMILERVERSION, CKCT.FRTPCMILERVERSION, CKCT.CUSTOMERSATISFACTIONINDEX];
  hhgControlTypes = [CKCT.HHGPCMILERVERSION, CKCT.CUSTOMERSATISFACTIONINDEX];
  frtControlTypes = [CKCT.FRTPCMILERVERSION];
  showPcmilerVersion: boolean;
  controlKeysTable: boolean;
  controlKeysColumnDefs: any;
  hhgFrtPcMilerVersionColumnDefs = [
    {headerName: 'Control Type', field: 'controlType'},
    {
      headerName: 'Version', field: 'rateKey',
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.rateKey + '</a>',
      onCellClicked: event => this.onHHGOrFRTPCMilerSelected(event.data)
    },
    {
      headerName: 'Effective Date', field: 'effectiveDate', cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Expiry Date', field: 'expiryDate', cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    }
  ];

  customerSatisfactionIndexColumnDefs = [
    {headerName: 'Control Type', field: 'controlType'},
    {headerName: 'Effective Date', field: 'effectiveDate'},
    {headerName: 'Expiry Date', field: 'expiryDate'}
  ];
  controlKeyDetails = [];
  showControlKeysTable: boolean;
  controlKeysEntity: ControlKeys;
  showDieselPriceFields: boolean;
  year: any;
  years = [];
  frtDieselPriceEntity: FrtDieselPrice;
  showDieselPriceTable: boolean;
  dieselPriceDetails = [];
  dieselPriceColumnDefs = [
    {headerName: 'Monday Date', field: 'currentWeekMondayDate', filter: 'agTextColumnFilter', sortable: true, cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Price',
      field: 'dieselPrice',
      filter: 'agTextColumnFilter',
      sortable: true,
      editable: true,
      valueFormatter: this.masterdataAdminService.formatNumber
    }
  ];
  showZonesFields: boolean;
  agencyCustomerList: AgencyMaster[];
  agencyBureauList: AgencyMaster[];
  showCreateAgency: Boolean = false;
  agencyCode: string;
  bureauCode: string;
  agencyMaster: AgencyMaster;
  agencyMasterSelected: AgencyMaster;
  frtZones: FrtRatesZone[];
  frtRatesZoneEntity: FrtRatesZone;
  zonecodetypeaheadlist: string[];
  zonenametypeaheadlist: string[];
  zoneCodeList: string[] = [];
  zoneNameList: string[] = [];
  zoneCodeMinLengthToSearch: number;
  zoneCodeMaxCharLength: number;
  zoneNameMinLengthToSearch: number;
  zoneNameMaxCharLength: number;
  showZonesTable: boolean;
  zonesColumnDefs = [
    {
      headerName: 'Zone Code', field: 'zoneCode', filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.zoneCode + '</a>',
      onCellClicked: event => this.onZoneCodeClicked(event.data)
    },
    {headerName: 'Zone Name', field: 'zoneName', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'City Name', field: 'zoneCity', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'State Code', field: 'zoneState', width: 100, filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Zip Code', field: 'zoneZip', width: 100, sortable: true},
    // { headerName: 'Agency Name', field: 'agencyName', filter: 'agTextColumnFilter', sortable:true},
    // { headerName: 'Bureau Name', field: 'bureauName', filter: 'agTextColumnFilter', sortable:true}
  ];
  showCustomerSatisfactionIndexFields: boolean;
  showCsiTable: boolean;
  csiRatePeriodDetails: ControlKeys[];
  csiDetails: any;
  csiColumnDefs = [
    {
      headerName: 'Scac', field: 'scac', filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.scac + '</a>',
      onCellClicked: event => this.onCarrierIdClick(event.data)
    },
    {headerName: 'Control Id', field: 'controlId'},
    {headerName: 'CSI Domestic', field: 'domesticCsi', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'CSI International', field: 'internationalCsi', filter: 'agTextColumnFilter', sortable: true}
  ];
  csiActiveCarriers: Carrier[];
  csiCarrier: Carrier;
  hhgCsiEntity: HhgCustomerSatisfactionIndex;
  dataSourceOrigin: Observable<any>;
  typeaheadOriginLoading: boolean;
  businessType: string;
  detailGridOptions: GridOptions;
  private isNoRowSelectedEvent$ = new BehaviorSubject(true);
  isNoRowSelected$ = this.isNoRowSelectedEvent$.asObservable();
  assignedCarriers: any[] = [];

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    this.gridOptionsApi = params.api;
    params.api.sizeColumnsToFit();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  /**
   * @description creates finalization form.
   */
  ngOnInit() {
    this.createForm();
    this.createCoreTspForm();
    this.showTable = false;
    this.showRfspsTable = false;
    this.showPcmilerVersion = false;
    this.showControlKeysTable = false;
    this.showDieselPriceTable = false;
    this.showZonesTable = false;
    this.showCsiTable = false;
    this.hhgCsiId = 0;

    this.dataSourceOrigin = new Observable((observer: any) => {
      this.ratesSroMasterService.getLocations(this.masterDataAdminForm.get('asyncOriginSearchString').value).subscribe((result: any) => {
        observer.next(result);
      });
    });

    this.masterDataAdminForm.get('originCity').valueChanges.subscribe(origin => {
      this.tmssLoader.show();
      if (origin) {
        this.masterDataAdminForm.get('city').setValue(origin.cityName);
        this.masterDataAdminForm.get('state').setValue(origin.stateAbbrev);
        this.stateCountryService.getStateCountryByStateCountryCode(
          origin.stateAbbrev).subscribe(
          stateCountry => {
            this.stateCountry = stateCountry;
            this.masterDataAdminForm.controls['stateId'].setValue(
              this.stateCountry.stateCountryId);
            this.tmssLoader.hide();
          }, (error) => {
            this.alertService.error('Error while getting origin city and state.');
            this.tmssLoader.hide();
          }
        );
        this.masterDataAdminForm.get('stateId').setValue(origin.stateId);
        this.masterDataAdminForm.get('zip').setValue(origin.zipCode);
      }
    });
    this.getCountryList();
    this.masterDataAdminForm.get('country').setValue(326);
    this.isCountryUsa = true;
    this.userService.getCurrentUserObservable().subscribe(currentUser => {
      if (currentUser) {
        this.businessType = currentUser.permissions;
        this.masterDataAdminTypes =  this.businessType === BT.HHG ? this.hhgSelection : this.businessType === BT.FRT ? this.frtSelection : this.hhgAndFrtSelection;
        this.controlKeysControlTypes =  this.businessType === BT.HHG ? this.hhgControlTypes : this.businessType === BT.FRT ? this.frtControlTypes : this.hhgAndFrtControlTypes;
      }
    }, (error) => {
      console.log("ERROR WHILE RETRIVING DATA", error);
    });
  }

  createCoreTspForm() {
    this.coreTspForm = this.fb.group({
      agencyGroup: new UntypedFormControl('', [Validators.required]),
      agencyEmails: new UntypedFormControl('', [Validators.required, commaSeparatedEmailsValidator()]),
      appCarriers: new UntypedFormControl(null),
      assignedCarriers: new UntypedFormControl(null)
    });
  }

  onTspSave() {
    const payload = this.coreTspForm.value;
    if (!this.isCoreTspEdit) {
      let tspList = [];
      if (this.assignedCarriers.length) {
          this.assignedCarriers.forEach(x => {
          const obj = {
            agencyGroup: payload.agencyGroup,
            agencyEmails: payload.agencyEmails,
            carrierId: x.carrierId,
            agencyTspCoreNotificationId: null,
            agencyTsp: ''
          }
          tspList.push(obj);
        });

      }
      this.loader.show();
      this.masterdataAdminService.saveNewAgencyTspCoreNotifications(tspList).subscribe(res => {
        this.loader.hide();
        this.createModal.hide();
        this.populateAgencyTspCoreNotifications();
        this.alertService.success("A new Agency Group has been added")
      }, error => {
        this.loader.hide();
        this.alertService.error("An error occurred while saving the data.")
      })
    } else {
      let tspList = [];
      if (this.assignedCarriers.length) {
          this.assignedCarriers.forEach(x => {
          const obj = {
            agencyGroup: payload.agencyGroup,
            agencyEmails: payload.agencyEmails,
            carrierId: x.carrierId,
            agencyTspCoreNotificationId: null,
            agencyTsp: ''
          }
          tspList.push(obj);
        });

      }
      this.loader.show();
      this.masterdataAdminService.updateAgencyTspCoreNotifications(tspList).subscribe(res => {
        this.loader.hide();
        this.createModal.hide();
        this.populateAgencyTspCoreNotifications();
        this.alertService.success("The Agency Group has been updated.")
      }, error => {
        this.loader.hide();
        this.alertService.error("An error occurred while saving the data.")
      })
    }
  }

  closeModal() {
    this.createModal.hide();
  }

  openCoreTspModal(action, data?: any) {
    this.assignedCarriers = [];
    this.coreTspForm.reset();
    this.isCoreTspEdit = action === 'edit';
    this.loader.show();
    this.carrierService.getAllSmallCarrierListByBusinessTypeAndStatus('HHG', 'Active').subscribe(carrierList => {
      this.carrierList = carrierList;
        if (this.isCoreTspEdit) {
            this.selectedCoreTsp = data;
            this.coreTspForm.get('agencyGroup').setValue(data.agencyGroup);
            this.coreTspForm.get('agencyEmails').setValue(data.agencyEmails);
            if (data.carrierId && data.carrierId.length > 0) {
                this.carrierList.forEach(e => {
                    data.carrierId.forEach(y => {
                        if (e.carrierId === y) {
                            this.assignedCarriers.push(e);
                        }
                    });
                });
            }
            this.coreTspForm.updateValueAndValidity();
        }
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Scac List');
    });
    this.createModal.show();
  }

  /**
   * @description intializes all the form controls
   */
  createForm() {
    this.masterDataAdminForm = this.fb.group({
      masterDataType: new UntypedFormControl(null, Validators.required),
      countryCode: new UntypedFormControl('', Validators.required),
      countryName: new UntypedFormControl('', Validators.required),
      serviceAreaCode: new UntypedFormControl('', Validators.required),
      description: new UntypedFormControl('', Validators.required),
      countyName: new UntypedFormControl('', Validators.required),
      stateAbbreviation: new UntypedFormControl('', Validators.required),
      countyCode: new UntypedFormControl('', Validators.required),
      iccId: new UntypedFormControl('', Validators.required),
      gsaServiceArea: new UntypedFormControl('', Validators.required),
      ratePeriod: new UntypedFormControl(null, Validators.required),
      freightRateType: new UntypedFormControl(null, Validators.required),
      sroId: new UntypedFormControl(null, Validators.required),
      ltlMinimumPct: new UntypedFormControl('', Validators.required),
      ltlMaximumPct: new UntypedFormControl('', Validators.required),
      tlMinimumPct: new UntypedFormControl('', Validators.required),
      tlMaximumPct: new UntypedFormControl('', Validators.required),
      carrierIdRfsp: new UntypedFormControl(null, Validators.required),
      carrierIdTsp: new UntypedFormControl('', Validators.required),
      shipmentType: new UntypedFormControl(null, Validators.required),
      controlTypeSelected: new UntypedFormControl(null, Validators.required),
      pcMilerVersion: new UntypedFormControl('', Validators.required),
      releasePending: new UntypedFormControl('', Validators.required),
      effectiveDate: new UntypedFormControl('', Validators.required),
      expiryDate: new UntypedFormControl('', Validators.required),
      releaseDate: new UntypedFormControl('', Validators.required),
      createdDate: new UntypedFormControl('', Validators.required),
      year: new UntypedFormControl(null, Validators.required),
      entryDate: new UntypedFormControl('', Validators.required),
      dollarsPerGallon: new UntypedFormControl('',
        [Validators.required,
          Validators.maxLength(5)]
      ),
      agencyName: new UntypedFormControl(null, Validators.required),
      bureauName: new UntypedFormControl(null, Validators.required),
      zoneCode: new UntypedFormControl('', Validators.required),
      zoneName: new UntypedFormControl('', Validators.required),
      country: new UntypedFormControl('', Validators.required),
      asyncOriginSearchString: new UntypedFormControl(null, []),
      originCity: new UntypedFormControl(null, []),
      city: new UntypedFormControl('', Validators.required),
      state: new UntypedFormControl('', Validators.required),
      stateId: new UntypedFormControl(null, []),
      zip: new UntypedFormControl('', Validators.required),
      isUSA: new UntypedFormControl(false, {validators: [Validators.required]}),
      csiRatePeriod: new UntypedFormControl('', Validators.required),
      csiScac: new UntypedFormControl('', [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
      csiDomestic: new UntypedFormControl(''),
      csiInternational: new UntypedFormControl(''),
    });
  }

  isCsiValid() {
    return this.masterDataAdminForm.get('csiScac').valid && (this.masterDataAdminForm.get('csiDomestic').value !== ''
      || this.masterDataAdminForm.get('csiInternational').value !== '');
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  /*
  * function triggers after cell editing in ag-grid
  * */
  onCellValueChanged($event) {
    this.tmssLoader.show();
    this.masterdataAdminService.saveFrtDieselPrice($event.data).subscribe(frtDieselPrice => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully inserted/Updated the Diesel Price');
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the Diesel Price ' + error);
      });
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    this.masterDataAdminForm.get('originCity').setValue(e.item);
  }

  /* getFormField for masterdata admin types  */
  getFormField(field: string): any {
    return this.masterDataAdminForm.get(field);
  }

  populateAgencyTspCoreNotifications() {
    this.masterdataAdminService.getAgencyTspCoreNotifications().subscribe(res => {
      this.agencyCoreTsps = this.mergeCoreTsps(res);
    }, error => {
      this.alertService.error('Error occurred while retrieving agency group(s). Please contact system administrator.')
    })
  }

  mergeUniqueNumbers(items, key) {
    const allValues = items.map(item => item[key]);
    return [...new Set(allValues)];
  }

  mergeUniqueStrings(items, key) {
    const allValues = items
      .map(item => item[key])
      .flatMap(val => val.split(', ').map(v => v.trim()));
    return [...new Set(allValues.filter(Boolean))].join(', ');
  }

  mergeCoreTsps(input: any) {

    const grouped = {};

    for (const item of input) {
      const groupKey = item.agencyGroup;
      if (!grouped[groupKey]) {
        grouped[groupKey] = [];
      }
      grouped[groupKey].push(item);
    }
    const result = Object.entries(grouped).map(([group, items]) => ({
      agencyGroup: group,
      agencyEmails: this.mergeUniqueStrings(items, 'agencyEmails'),
      agencyTsp: this.mergeUniqueStrings(items, 'agencyTsp'),
      agencyTspCoreNotificationId: this.mergeUniqueNumbers(items, 'agencyTspCoreNotificationId'),
      carrierId: this.mergeUniqueNumbers(items, 'carrierId'),
    }));

    return result;
  }

  masterDataTypeChange() {
    const masterDataAdminType = this.getFormField('masterDataType').value;
    switch (masterDataAdminType) {
      case MDT.COUNTRY:
        this.getFormField('countryCode').setValue(null);
        this.getFormField('countryName').setValue(null);
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCountryFields = true;
        this.showFreightServicesMasterFields = false;
        this.showCarrierRfsps = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showControlKeys = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.COUNTY:
        this.getFormField('countyName').setValue(null);
        this.getFormField('stateAbbreviation').setValue(null);
        this.getFormField('countyCode').setValue(null);
        this.getFormField('iccId').setValue(null);
        this.getFormField('gsaServiceArea').setValue(null);
        this.showServiceAreaFields = false;
        this.showCountryFields = false;
        this.showCountyFields = true;
        this.showFreightServicesMasterFields = false;
        this.showCarrierRfsps = false;
        this.showControlKeys = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.SERVICEAREA:
        this.getFormField('serviceAreaCode').setValue(null);
        this.getFormField('description').setValue(null);
        this.showCountryFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = true;
        this.showFreightServicesMasterFields = false;
        this.showCarrierRfsps = false;
        this.showControlKeys = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.FREIGHTSERVICESMASTER:
        this.showFreightServicesMasterFields = true;
        this.getFormField('ratePeriod').setValue('');
        this.getFormField('freightRateType').setValue('');
        this.getFormField('sroId').setValue('');
        this.findEffectiveAndExpiry();
        this.showCountryFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCarrierRfsps = false;
        this.showControlKeys = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.CARRIERRFSPS:
        this.getFormField('carrierIdRfsp').setValue(null);
        this.getFormField('carrierIdTsp').setValue(null);
        this.getFormField('shipmentType').setValue(null);
        this.showFreightServicesMasterFields = false;
        this.showCountryFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCarrierRfsps = true;
        this.showControlKeys = false;
        this.findCarrierRateFileServiceProvider();
        this.findCarrierTransportationServiceProvider();
        this.findAllRfspsAndCarriers();
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.CONTROLKEYS:
        this.getFormField('controlTypeSelected').setValue('');
        this.getFormField('pcMilerVersion').setValue(null);
        this.getFormField('effectiveDate').setValue(null);
        this.getFormField('expiryDate').setValue(null);
        this.showFreightServicesMasterFields = false;
        this.showCountryFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCarrierRfsps = false;
        this.showControlKeys = true;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.DIESELPRICE:
        this.getFormField('dollarsPerGallon').setValue('');
        this.getFormField('entryDate').setValue(null);
        this.showDieselPriceFields = true;
        this.populateYears();
        this.showFreightServicesMasterFields = false;
        this.showCountryFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCarrierRfsps = false;
        this.showControlKeys = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.ZONES:
        this.getFormField('agencyName').setValue(null);
        this.getFormField('bureauName').setValue(null);
        this.getFormField('zoneCode').setValue(null);
        this.getFormField('zoneName').setValue(null);
        this.getFormField('city').setValue(null);
        this.getFormField('state').setValue(null);
        this.getFormField('zip').setValue(null);
        this.showZonesFields = true;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCountryFields = false;
        this.showFreightServicesMasterFields = false;
        this.showCarrierRfsps = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showControlKeys = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.populateAgency();
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        // this.populateZones();
        break;
      case MDT.CUSTOMERSATISFACTIONINDEX:
        this.getFormField('csiScac').setValue('');
        this.getFormField('csiDomestic').setValue('');
        this.getFormField('csiInternational').setValue('');
        this.findCsiEffectiveAndExpiry();
        this.showCustomerSatisfactionIndexFields = true;
        this.showCsiTable = false;
        this.showZonesFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCountryFields = false;
        this.showFreightServicesMasterFields = false;
        this.showCarrierRfsps = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showControlKeys = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = true;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
      case MDT.CORETSPINDENTIFICATION:
        this.showCoreTsp = true;
        this.populateAgencyTspCoreNotifications();
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showZonesFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCountryFields = false;
        this.showFreightServicesMasterFields = false;
        this.showCarrierRfsps = false;
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showControlKeys = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesTable = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.detailGridOptions = <GridOptions>{
          columnDefs: this.coreTspColumnDefs,
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressAndOrCondition: false
            }
          },
          masterDetail: true,
          headerHeight: 50,
          pagination: true,
          paginationPageSize: 25,
          cacheBlockSize: 25,
          // domLayout: 'autoHeight',
          suppressRowClickSelection: true,
          rowMultiSelectWithClick: true,
          suppressDragLeaveHidesColumns: true,
          detailCellRendererParams: {
            detailGridOptions: this.detailGridOptions,
            /*getDetailRowData: params => {
              this.loader.show();
              this.updateIFFShipmentDetailRequestFn(params.data['iffMasterId'])
                .pipe(takeWhile(() => this.observer$.value))
                .subscribe(results => {
                  params.successCallback(results);
                  this.loader.hide();
                }, error => this.loader.hide());
            }*/
          },
          isRowMaster: rowData => rowData ? rowData.numberOfShipments > 0 : false,
          onGridReady: params => {
            this.gridOptionsApi = params.api;
            params.api.sizeColumnsToFit();
            // params.api.setDatasource(this.getIFFShipmentQueryDataSource(this.updateIFFShipmentPaginationRequestFn,
            //   this.IFFShipmentPaginationResults$));
          },
          onSelectionChanged: params => {
            const selectedRows = params.api.getSelectedNodes();
            if (selectedRows && selectedRows.length > 0) {
              this.isNoRowSelectedEvent$.next(false);
            } else {
              this.isNoRowSelectedEvent$.next(true);
            }
          },
          defaultExportParams: {
            getCustomContentBelowRow: params => {
              return [];
            }
          },
          overlayLoadingTemplate:
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
          overlayNoRowsTemplate:
            '<span>No results found. Please adjust your filters.</span>'
        };
        break;
        default:
        this.showControlKeys = false;
        this.showCarrierRfsps = false;
        this.showFreightServicesMasterFields = false;
        this.showCountyFields = false;
        this.showServiceAreaFields = false;
        this.showCountryFields = true;
        this.getFormField('countryCode').setValue(null);
        this.getFormField('countryName').setValue(null);
        this.showTable = false;
        this.showRfspsTable = false;
        this.showControlKeysTable = false;
        this.showDieselPriceFields = false;
        this.showDieselPriceTable = false;
        this.showZonesFields = false;
        this.showCustomerSatisfactionIndexFields = false;
        this.showCsiTable = false;
        this.showCoreTsp = false;
        break;
    }

  }

  // save or update state country record
  saveOrUpdateStateCountry() {
    this.tmssLoader.show();
    this.stateCountryEntity = new StateCountry();

    if ((this.masterDataAdminForm.controls['masterDataType'].value) === 'Country') {
      this.stateCountryType = 'Country';
      this.stateCountryEntity.stateCountryName = this.masterDataAdminForm.value.countryName;
      this.stateCountryEntity.stateCountryCode = this.masterDataAdminForm.value.countryCode;
    } else if ((this.masterDataAdminForm.controls['masterDataType'].value) === 'Service Area') {
      this.stateCountryType = 'Service Area';
      this.stateCountryEntity.stateCountryName = this.masterDataAdminForm.value.description;
      this.stateCountryEntity.stateCountryCode = this.masterDataAdminForm.value.serviceAreaCode;
    } else if ((this.masterDataAdminForm.controls['masterDataType'].value) === 'Zones') {
      this.stateCountryType = 'Zone';
    }
    this.stateCountryEntity.stateCountryType = this.stateCountryType;
    this.stateCountryEntity.stateCountryCode2Digit = '';
    this.stateCountryEntity.schedule = '';
    // this.stateCountryEntity.deptOfState = false;
    this.stateCountryEntity.serviceAreaId = null;
    this.stateCountryEntity.parentCountryId = 0;
    this.stateCountryEntity.contiguousUS = 0;
    this.stateCountryEntity.updateProgram = '';
    this.stateCountryEntity.updateId = 0;
    this.stateCountryEntity.frtRatesZoneId = null;
    this.stateCountryEntity.updateDate = new Date();
    this.stateCountryEntity.businessType = this.businessType;
    if(this.showCountryFields){
      this.masterdataAdminService.saveorUpdateStateCountryByCountry(this.stateCountryEntity).subscribe(stateCountry => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully inserted/Updated the ' + this.stateCountryType);
        this.clearFormByType(this.stateCountryType);
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the ' + this.stateCountryType + error);
      });
    }

      if(this.showServiceAreaFields){
        this.masterdataAdminService.saveorUpdateStateCountryByServiceArea(this.stateCountryEntity).subscribe(stateCountry => {
          this.tmssLoader.hide();
          this.alertService.success('Successfully inserted/Updated the ' + this.stateCountryType);
          this.clearFormByType(this.stateCountryType);
        },
        error => {
          this.tmssLoader.hide();
          this.alertService.error('Error while saving/updating the ' + this.stateCountryType + error);
        });
      }
  }

  // Function is used to find the state country details by country code and country type
  findCountryDetails(countryCode: string) {
    if (countryCode != null) {
      this.countryCode = countryCode;
      if ((this.masterDataAdminForm.controls['masterDataType'].value) === 'Country') {
        this.stateCountryType = 'Country';
      } else if ((this.masterDataAdminForm.controls['masterDataType'].value) === 'Service Area') {
        this.stateCountryType = 'Service Area';
      }
      this.masterdataAdminService.getStateCountryByStateCountryCode(
        this.countryCode, this.stateCountryType).subscribe(
        stateCountry => {
          this.stateCountry = stateCountry;
          if(AppConstants.isNotNullCondition(this.stateCountry?.businessType) && this.businessType === this.stateCountry?.businessType)
            this.businessType = this.stateCountry.businessType ;
          if (this.stateCountry != null) {
            if (this.stateCountryType === 'Country') {
              this.masterDataAdminForm.controls['countryName'].setValue(
                this.stateCountry.stateCountryName);
            } else if (this.stateCountryType === 'Service Area') {
              this.masterDataAdminForm.controls['description'].setValue(
                this.stateCountry.stateCountryName);
            }
          } else {
            if (this.stateCountryType === 'Country') {
              this.getFormField('countryName').setValue(null);
              this.alertService.error('Country code could not be found.Please create a new Country by entering a code and a name.');
            } else if (this.stateCountryType === 'Service Area') {
              this.getFormField('description').setValue(null);
              this.alertService.error('Service Area could not be found.Please create a new Service Area by entering a code and description.');
            }
          }
        }, (error) => {
          if (this.stateCountryType === 'Country') {
            this.getFormField('countryName').setValue(null);
            this.alertService.error('Error while retrieving Country. Please retry.');
          } else if (this.stateCountryType === 'Service Area') {
            this.getFormField('serviceAreaCode').setValue(null);
            this.alertService.error('Error while retrieving Service Area. Please retry.');
          }
        }
      );
    }
  }

  // function to delete the existing state country
  deleteStateCountry() {
    if (this.stateCountry == null) {
      this.stateCountry = {};
    }
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this State Country';
    this.modalRef.content.title = 'Deleting State Country';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        if(this.showCountryFields){
          this.masterdataAdminService.deleteStateCountryByCountry(this.stateCountry).subscribe(() => {
            this.tmssLoader.hide();
            this.alertService.success('Successfully Deleted State Country');
            this.clearFormByType(this.getFormField('masterDataType').value);
          }, error => {
            this.tmssLoader.hide();
            this.alertService.error('There was an error deleting State Country');
          });
        }
        if(this.showServiceAreaFields){
          this.masterdataAdminService.deleteStateCountryByServiceArea(this.stateCountry).subscribe(() => {
            this.tmssLoader.hide();
            this.alertService.success('Successfully Deleted State Country');
            this.clearFormByType(this.getFormField('masterDataType').value);
          }, error => {
            this.tmssLoader.hide();
            this.alertService.error('There was an error deleting State Country');
          });
        }
      }
    });
  }

  // Function is used to find the County details by County name and State code
  findCountyDetails(countyName: string, stateAbbreviation: string) {
    if (countyName != null && stateAbbreviation != null) {
      this.countyName = countyName;
      this.stateAbbreviation = stateAbbreviation;
      this.masterdataAdminService.getCountyByCountyNameAndStateCode(
        this.countyName, this.stateAbbreviation).subscribe(
        county => {
          if (county != null) {
            this.county = county;
            this.masterDataAdminForm.controls['countyCode'].setValue(
              this.county.countyCode);
            this.masterdataAdminService.getHhgIccyById(this.county.iccId).subscribe(hhgIcc => {
              if (hhgIcc != null) {
                this.hhgIcc = hhgIcc;
                this.masterDataAdminForm.controls['iccId'].setValue(
                  this.hhgIcc.iccCode);
              } else {
                this.alertService.error('ICC code could not found. Please retry.');
              }
            });
            this.masterdataAdminService.getStateCountryById(this.county.serviceAreaId).subscribe(stateCountry => {
              if (stateCountry != null) {
                this.stateCountry = stateCountry;
                this.masterDataAdminForm.controls['gsaServiceArea'].setValue(
                  this.stateCountry.stateCountryCode);
              } else {
                this.alertService.error('State Country code could not found. Please retry.');
              }
            });
          } else {
            this.getFormField('countyName').setValue(null);
            this.getFormField('stateAbbreviation').setValue(null);
            this.getFormField('countyCode').setValue(null);
            this.getFormField('iccId').setValue(null);
            this.getFormField('gsaServiceArea').setValue(null);
            this.alertService.error('County could not found. Please retry');
          }
        }, (error) => {
          this.getFormField('countyName').setValue(null);
          this.getFormField('stateAbbreviation').setValue(null);
          this.getFormField('countyCode').setValue(null);
          this.getFormField('iccId').setValue(null);
          this.getFormField('gsaServiceArea').setValue(null);
          this.alertService.error('Error while retrieving County details. Please retry.');
        }
      );
    }
  }

  // save or update state country record
  // Remove the masterDataForm using masterdataadminform
  saveOrUpdateCounty() {
    this.tmssLoader.show();
    if (this.county == null) {
      this.county = {};
    }
    this.county.countyName = this.masterDataAdminForm.value.countyName;
    this.county.countyCode = this.masterDataAdminForm.value.countyCode;
    this.masterdataAdminService.getHhgIccyByCode(this.masterDataAdminForm.value.iccId).subscribe(hhgIcc => {
      this.tmssLoader.hide();
      if (hhgIcc != null) {
        this.county.iccId = hhgIcc.iccId;
      } else {
        this.hhgIccEntity = new HhgIcc();
        this.hhgIccEntity.iccCode = this.masterDataAdminForm.value.iccId;
        this.hhgIccEntity.updateDate = new Date();
        this.hhgIccEntity.updateId = 0;
        this.hhgIccEntity.updateProgram = '';
        this.masterdataAdminService.saveorUpdateHhgIcc(this.hhgIccEntity).subscribe(newHhgIcc => {
            this.tmssLoader.hide();
            if (newHhgIcc != null) {
              this.county.iccId = newHhgIcc.iccId;
            }
          },
          error => {
            this.tmssLoader.hide();
          });
      }
    });
    this.county.city = '';
    this.county.state = 0;
    this.county.stateCode = 0;
    this.masterdataAdminService.getStateCountryByCode(this.masterDataAdminForm.value.gsaServiceArea).subscribe(existingStateCountry => {
      this.tmssLoader.hide();
      if (existingStateCountry != null) {
        this.county.serviceAreaId = existingStateCountry.stateCountryId;
      } else {
        this.tmssLoader.hide();
        this.alertService.error('GSA Service Area could not found.Please create one.');
      }
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('GSA Service Area could not found.Please create one.');
    });
    this.county.updateProgram = '';
    this.county.updateId = 0;
    this.county.updateDate = new Date();
    if (this.county.serviceAreaId != null) {
      this.masterdataAdminService.saveorUpdateCounty(this.county).subscribe(county => {
          this.tmssLoader.hide();
          this.alertService.success('Successfully inserted/Updated the County');
          this.clearFormByType('County');
        },
        error => {
          this.tmssLoader.hide();
          this.alertService.error('Error while saving/updating the County ' + error);
        });
    }
  }

  deleteCounty() {
    if (this.county == null) {
      this.county = {};
    }
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this County';
    this.modalRef.content.title = 'Deleting County';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.masterdataAdminService.deleteCounty(this.county).subscribe(() => {
          this.tmssLoader.hide();
          this.alertService.success('Successfully Deleted County');
          this.clearFormByType(this.getFormField('masterDataType').value);
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('There was an error deleting County');
        });
      }
    });
  }

  /*
 * When user changes the sro id, find the control key for the rate period by control id
 * and check if control key's Release Pending = "Released".If yes, then show the table (Effective Date, Expiry Date, SRO ID, Service level, LTL or TL max pct and LTL orTL min pct.), based on the service level(LTL or TL)
 * else if it is pending then show the LTL and TL feilds based on the service level for each Sro id.
 */

  findControlKeyReleasePending() {
    const selectedRatePeriod = this.getFormField('ratePeriod').value;
    this.masterdataAdminService.getControlKeysByControlId(+selectedRatePeriod).subscribe(controlKey => {
      this.controlKey = controlKey;
      if (this.controlKey != null) {
        if (this.controlKey.releasePending === 'Released') {
          this.showTable = true;
          this.showltl = false;
          this.showtl = false;
          this.getFormField('sroId').disable();
          this.populateGrid();
        } else {
          this.getFormField('sroId').enable();
          this.masterdataAdminService.getSros(this.rateTypeId).subscribe(allSros => {
            this.sroIdList = allSros;
            this.showTable = false;
          }, error => {
            this.alertService.error('There was an error retrieving SRO List');
          });
        }
      }
    }, error => {
      this.alertService.error('Error while retrieving control key by control id');
    });
  }

  findEffectiveAndExpiry() {
    this.tmssLoader.show();
    this.masterdataAdminService.getControlKeysByControlType('FRT Rate Filing')
      .subscribe(controlKeys => {
        this.ratePeriodDetails = controlKeys;
        (controlKeys as ControlKeys[]);
        controlKeys.forEach(controlKey => {
          controlKeys.effectiveDate = controlKey.effectiveDate;
          controlKeys.expiryDate = controlKey.expiryDate;
          controlKeys.controlId = controlKey.controlId;
          this.tmssLoader.hide();
        }, (error) => {
          this.alertService.error('Rate Period Record did not get populated');
          this.tmssLoader.hide();
        });
      });
  }

  freightRateTypeChange() {
    const freightRateTypeValue = this.getFormField('freightRateType').value;
    const selectedSroMasterId = this.getFormField('sroId').value;
    this.masterdataAdminService.getFrtServicesByServiceLevelAndSroMasterId(freightRateTypeValue, +selectedSroMasterId).subscribe(frtServicesMaster => {
      if (frtServicesMaster != null) {
        this.ltlMaximumPct = frtServicesMaster.ltlMaximumChargePct;
        this.ltlMinimumPct = frtServicesMaster.ltlMinimumChargePct;
        this.tlMaximumPct = frtServicesMaster.tlMaximumCharge;
        this.tlMinimumPct = frtServicesMaster.tlMinimumCharge;
      }
    });
    switch (freightRateTypeValue) {
      case RT.LTL:
        this.showltl = true;
        this.showtl = false;
        this.getFormField('ltlMinimumPct').setValue(this.ltlMinimumPct);
        this.getFormField('ltlMaximumPct').setValue(this.ltlMaximumPct);
        break;
      case RT.TL:
        this.showltl = false;
        this.showtl = true;
        this.getFormField('tlMinimumPct').setValue(this.tlMinimumPct);
        this.getFormField('tlMaximumPct').setValue(this.tlMaximumPct);
        break;
      default:
        this.showltl = true;
        this.showtl = false;
        this.getFormField('ltlMinimumPct').setValue(this.ltlMinimumPct);
        this.getFormField('ltlMaximumPct').setValue(this.ltlMaximumPct);
        break;
    }

  }

  onRatePeriodChange() {
    this.getFormField('freightRateType').setValue('');

  }

  onRateTypeChange() {
    this.showTable = false;
    this.getFormField('sroId').setValue('');
    const rateType = this.getFormField('freightRateType').value;
    if (rateType !== '') {
      this.rateTypeId = rateType === 'LTL' ? 19 : 18,
        this.masterdataAdminService.getSros(this.rateTypeId).subscribe(allSros => {
          this.sroIdList = allSros;
        }, error => {
          this.alertService.error('There was an error retrieving SRO List');
        });
    }
    this.columnDefs = rateType === 'LTL' ? this.freightListLtlColumnDefs : rateType === 'TL' ? this.freightListTlColumnDefs : [];
    this.findControlKeyReleasePending();
  }


  onSroIdChange() {
    this.showTable = false;
    this.freightRateTypeChange();
  }

  populateGrid() {
    const selectedControlId = this.getFormField('ratePeriod').value;
    const selectedServiceLevel = this.getFormField('freightRateType').value;
    this.masterdataAdminService.getFrtServicesMasterByControlIdAndServiceLevel(+selectedControlId, selectedServiceLevel).subscribe(frtServicesMasterData => {
        this.frtRatePeriodDetails = frtServicesMasterData;
        this.frtRatePeriodDetails.forEach(element => {
          element.effectiveDate = this.controlKey.effectiveDate;
          element.expiryDate = this.controlKey.expiryDate;
        });
      },
      error => {
        this.alertService.error('Error while retrieving Frt Services Master list');
      });

  }

  saveFreightServiceMaster() {
    this.tmssLoader.show();
    if (this.freightServicesMaster == null) {
      this.freightServicesMaster = {};
    }
    this.freightServicesMaster.controlId = this.masterDataAdminForm.value.ratePeriod;
    this.freightServicesMaster.sroMasterId = this.masterDataAdminForm.value.sroId;
    this.freightServicesMaster.serviceLevel = this.masterDataAdminForm.value.freightRateType;
    if (this.showltl) {
      this.freightServicesMaster.ltlMaximumChargePct = this.masterDataAdminForm.value.ltlMinimumPct;
      this.freightServicesMaster.ltlMinimumChargePct = this.masterDataAdminForm.value.ltlMaximumPct;
    } else {
      this.freightServicesMaster.ltlMaximumChargePct = 0.00;
      this.freightServicesMaster.ltlMinimumChargePct = 0.00;
    }
    if (this.showtl) {
      this.freightServicesMaster.tlMinimumCharge = this.masterDataAdminForm.value.tlMinimumPct;
      this.freightServicesMaster.tlMaximumCharge = this.masterDataAdminForm.value.tlMaximumCharge;
    } else {
      this.freightServicesMaster.tlMinimumCharge = 0.00;
      this.freightServicesMaster.tlMaximumCharge = 0.00;
    }
    this.freightServicesMaster.updateProgram = '';
    this.freightServicesMaster.updateId = 0;
    this.freightServicesMaster.updateDate = new Date();
    this.masterdataAdminService.saveorUpdateFreightServicesMaster(this.freightServicesMaster).subscribe(frtServicesMaster => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully inserted/Updated the Freight Services Master');
        this.clearFormByType('Freight Services Master');
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the Freight Services Master ' + error);
      });
  }

  findControlTypes() {
    this.tmssLoader.show();
    this.masterdataAdminService.getControlTypes()
      .subscribe(controlTypes => {
        this.controlTypes = controlTypes;
        this.controlTypes.forEach(controlType => {
          controlType = this.ct;
        });
        this.tmssLoader.hide();
      }, (error) => {
        this.alertService.error('Control types did not get populated');
        this.tmssLoader.hide();
      });
  }

  // Function to get the list of carrier rfsps (only ids) by carrier type RFSP and business type === 'HHG' OR 'HHG & FRT'
  findCarrierRateFileServiceProvider() {
    this.tmssLoader.show();
    this.masterdataAdminService.getCarrierRfspsByCarrierTypeRfsp().subscribe(carrierRfsps => {
      this.tmssLoader.hide();
      this.carrierRfsps = carrierRfsps.filter(e => e.carrierStatus !== 'Deleted');
      (carrierRfsps as Carrier[]);
      this.carrierRfsps.forEach(carrierRfsp => {
        this.crfsps = carrierRfsp.scac;
      });

    }, (error) => {
      this.alertService.error('Could not find Rate file Service provider');
      this.tmssLoader.hide();
    });
  }

  // Function to get the list of carriers by carrier type!== RFSP and business type === 'HHG' OR 'HHG & FRT'
  findCarrierTransportationServiceProvider() {
    this.tmssLoader.show();
    this.masterdataAdminService.getCarrierByNotRfspAndBusinessType().subscribe(carriertsps => {
      this.tmssLoader.hide();
      for (const carriertsp of carriertsps) {
        this.scacCodeList.push(carriertsp.scac);
      }
      this.typeaheadlist = this.scacCodeList;
    }, (error) => {
      this.alertService.error('Could not find the Transportation Service Provider');
      this.tmssLoader.hide();
    });
  }

  findAllRfspsAndCarriers() {
    this.masterdataAdminService.getAllRfspCarriers().subscribe(carrierRateFileServiceProvider => {
        this.allCarrierRfsps = carrierRateFileServiceProvider;
        this.populateCarrierRfspsGrid();
      },
      error => {
        this.alertService.error('Error while retrieving Carrier Rfsps');
      });
  }

  populateCarrierRfspsGrid() {
    const selectedCarrierRfspsId = this.getFormField('carrierIdRfsp').value;
    this.carrierRfspsDetails = [];
    /*
    this.masterdataAdminService.getCarrierRfspsByCarrierIdRfsp(selectedCarrierRfspsId.carrierId).subscribe(carrierRateFileServiceProvider => {
            this.carrierRfspsDetails = carrierRateFileServiceProvider;

        }
        error => {
            this.alertService.error('Error while retrieving Carrier Rfsps');
        });
    */

    this.allCarrierRfsps.forEach(e => {
      if (e.rfspScac === this.selectedCarrierRfsp && e.deleted === false) {
        this.carrierRfspsDetails.push(e);
      }
    });
  }

  onCarrierIdRfspsChange() {
    this.showRfspsTable = true;
    this.selectedCarrierRfsp = this.getFormField('carrierIdRfsp').value;
    this.populateCarrierRfspsGrid();
  }

  onCarrierRfspSelected(selectedScac) {
    this.loader.show();
    this.masterdataAdminService.getCarrierByCarrierIdTsp(selectedScac.carrierIdTsp).subscribe(carrier => {
        this.loader.hide();
        if (carrier != null) {
          this.getFormField('carrierIdRfsp').setValue(selectedScac.rfspScac);
          this.getFormField('carrierIdTsp').setValue(carrier.scac);
          this.getFormField('shipmentType').setValue(selectedScac.shipmentType);
        }
      },
      error => {
        this.loader.hide();
        this.alertService.error('Error while retrieving Carrier');
      });
  }

  findCarrierByScac() {
    this.masterdataAdminService.getCarrierByScac(this.masterDataAdminForm.value.carrierIdTsp).subscribe(carrier => {
        this.tmssLoader.hide();
        if (carrier !== null) {
          this.carrierRFSPType = carrier;
        }
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while retrieving Carrier');
      });
    return this.carrierRFSPType;

  }

  saveOrUpdateCarrierRfsps() {
    this.tmssLoader.show();

    this.saveDupError = false;
    this.carrierRfspsDetails.forEach(element => {
      // if((element.rfspScac === this.masterDataAdminForm.controls['carrierIdRfsp'].value.scac) &&
      if ((element.tspScac === this.masterDataAdminForm.controls['carrierIdTsp'].value) &&
        (element.shipmentType === this.masterDataAdminForm.controls['shipmentType'].value)) {
        this.tmssLoader.hide();
        this.saveDupError = true;
        this.alertService.error('The record already exists with this RFSP.');
      }
    });
    if (this.saveDupError) {
      return;
    }
    this.allCarrierRfsps.forEach(e => {
      if ((e.tspScac === this.masterDataAdminForm.controls['carrierIdTsp'].value) &&
        (e.shipmentType === this.masterDataAdminForm.controls['shipmentType'].value)) {
        this.tmssLoader.hide();
        this.saveDupError = true;
        this.alertService.error('The record already exists with another RFSP.');
      }
    });
    if (this.saveDupError) {
      return;
    }
    this.masterdataAdminService.getCarrierByScac(this.masterDataAdminForm.value.carrierIdTsp).subscribe(carrier => {
        if (carrier !== null) {
          this.carrierRFSPType = carrier;
          this.carrierRfspsEntity = new CarrierRfsps();
          const x = this.getFormField('carrierIdRfsp').value;
          let selectedCarrierRfspId;
          this.carrierRfsps.forEach(e => {
            if (e.scac === x) {
              selectedCarrierRfspId = e;
            }
          });

          this.carrierRfspsEntity.carrierIdRfsp = selectedCarrierRfspId.carrierId;
          this.carrierRfspsEntity.carrierIdTsp = this.carrierRFSPType.carrierId;
          this.carrierRfspsEntity.shipmentType = this.masterDataAdminForm.value.shipmentType;
          this.carrierRfspsEntity.updateProgram = '';
          this.carrierRfspsEntity.updateId = 0;
          this.carrierRfspsEntity.updateDate = new Date();

          this.masterdataAdminService.saveOrUpdateCarrierRfsps(this.carrierRfspsEntity).subscribe(carrierRfsps => {
              // this.allCarrierRfsps.push(this.carrierRfspsEntity);
              this.findAllRfspsAndCarriers();
              // this.populateCarrierRfspsGrid();
              this.tmssLoader.hide();
              this.alertService.success('Successfully inserted/Updated the Carrier RFSPS');
              this.clearFormByType(MDT.CARRIERRFSPS);
            },
            error => {
              this.tmssLoader.hide();
              this.alertService.error('Error while saving/updating the Carrier RFSPS ' + error);
            });
        }
        this.tmssLoader.hide();
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while retrieving Carrier');
      });
    /*
            console.log(this.getFormField('carrierIdTsp').value);
            console.log(this.carrierRFSPType);
            if(this.carrierRFSPType !== null || this .carrierRFSPType !== undefined)
            {
            this.carrierRfspsEntity = new CarrierRfsps();
            const selectedCarrierRfspId = this.getFormField('carrierIdRfsp').value;
            this.carrierRfspsEntity.carrierIdRfsp = selectedCarrierRfspId.carrierId;
            this.carrierRfspsEntity.carrierIdTsp = this.carrierRFSPType.carrierId;
            this.carrierRfspsEntity.shipmentType = this.masterDataAdminForm.value.shipmentType;
            this.carrierRfspsEntity.updateProgram = '';
            this.carrierRfspsEntity.updateId = 0;
            this.carrierRfspsEntity.updateDate = new Date();

            this.masterdataAdminService.saveOrUpdateCarrierRfsps(this.carrierRfspsEntity).subscribe(carrierRfsps => {
                    this.populateCarrierRfspsGrid();
                    this.tmssLoader.hide();
                    this.alertService.success('Successfully inserted/Updated the Carrier RFSPS');
                    this.clearFormByType('Carrier Rate File Service Provider');
                },
                error => {
                    this.tmssLoader.hide();
                    this.alertService.error('Error while saving/updating the Carrier RFSPS ' + error);
                });
            } else {
                this.tmssLoader.hide();
                this.alertService.error('Error has happened. Please try again ');
            } */
  }

  // function to delete the existing Carrier RFSPS
  deleteCarrierRfsps() {
    this.carrierRfspsDetails.forEach(element => {
      if ((element.rfspScac === this.masterDataAdminForm.controls['carrierIdRfsp'].value) &&
        (element.tspScac === this.masterDataAdminForm.controls['carrierIdTsp'].value) &&
        (element.shipmentType === this.masterDataAdminForm.controls['shipmentType'].value)) {
        this.carrierRfspsEntity = element;
      }
    });
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this Carrier RFSPS';
    this.modalRef.content.title = 'Deleting Carrier RFSPS';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.masterdataAdminService.deleteCarrierRfsps(this.carrierRfspsEntity).subscribe(() => {
          this.findAllRfspsAndCarriers();
          // this.populateCarrierRfspsGrid();
          this.tmssLoader.hide();
          this.alertService.success('Successfully Deleted TSP Rate File Service Provider');
          this.clearFormByType(this.getFormField('masterDataType').value);
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('There was an error deleting TSP Rate File Service Provider');
        });
      }
    });
  }


  onControlTypeChange() {

    const selectedControlType = this.getFormField('controlTypeSelected').value;
    if (selectedControlType === ('HHG PCMiler Version') || ('FRT PCMiler Version')) {
      this.getFormField('pcMilerVersion').setValue(null);
      this.showPcmilerVersion = true;
      this.showControlKeysTable = true;
      this.controlKeysColumnDefs = this.hhgFrtPcMilerVersionColumnDefs;
    } else if (selectedControlType === 'Customer Satisfaction Index') {
      this.showPcmilerVersion = false;
      this.showControlKeysTable = true;
      this.controlKeysColumnDefs = this.customerSatisfactionIndexColumnDefs;
    }
    this.masterdataAdminService.getControlKeysByControlType(selectedControlType).subscribe(controlKeysResult => {
        this.controlKeyDetails = controlKeysResult;
      },
      error => {
        this.alertService.error('Error while retrieving Control Keys');
      });
  }

  onHHGOrFRTPCMilerSelected(selectedPCMilerVersion) {
    this.showPcmilerVersion = true;
    this.getFormField('controlTypeSelected').setValue(selectedPCMilerVersion.controlType);
    this.getFormField('pcMilerVersion').setValue(selectedPCMilerVersion.rateKey);
    this.getFormField('effectiveDate').setValue(new Date(selectedPCMilerVersion.effectiveDate));
    this.getFormField('expiryDate').setValue(new Date(selectedPCMilerVersion.expiryDate));
  }

  saveOrUpdateControlKeys() {
    this.tmssLoader.show();
    this.controlKeysEntity = new ControlKeys();
    this.controlKeysEntity.controlType = this.masterDataAdminForm.value.controlTypeSelected;
    this.controlKeysEntity.rateKey = this.masterDataAdminForm.value.pcMilerVersion;
    this.controlKeysEntity.effectiveDate = this.masterDataAdminForm.value.effectiveDate;
    this.controlKeysEntity.expiryDate = this.masterDataAdminForm.value.expiryDate;
    this.controlKeysEntity.releasePending = 'Released';
    this.controlKeysEntity.releaseDate = new Date();
    this.controlKeysEntity.filingType = 'Main';
    this.controlKeysEntity.cycleName = '';
    this.controlKeysEntity.updateProgram = '';
    this.controlKeysEntity.updateId = 0;
    this.controlKeysEntity.updateDate = new Date();
    this.controlKeysEntity.createdDate = new Date();
    this.masterdataAdminService.saveOrUpdateControlKeys(this.controlKeysEntity).subscribe(controlKeys => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully inserted/Updated the Control Keys');
        this.masterdataAdminService.getControlKeysByControlType(this.masterDataAdminForm.value.controlTypeSelected).subscribe(controlKeysResult => {
            this.controlKeyDetails = controlKeysResult;
          },
          error => {
            this.alertService.error('Error while retrieving Control Keys');
          });
        this.clearFormByType('Control Keys');
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the Control Keys ' + error);
      });

  }

  deleteControlKeys() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this Control Keys record';
    this.modalRef.content.title = 'Deleting Control Keys';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.controlKeyDetails.forEach(element => {
      if (element.rateKey == this.getFormField('pcMilerVersion').value) {
        this.controlKeysEntity = element;
      }
    });
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.masterdataAdminService.deleteControlKeysRecord(this.controlKeysEntity).subscribe(() => {
          this.tmssLoader.hide();
          this.alertService.success('Successfully Deleted Control Keys');
          this.masterdataAdminService.getControlKeysByControlType(this.masterDataAdminForm.value.controlTypeSelected).subscribe(controlKeysResult => {
              this.controlKeyDetails = controlKeysResult;
            },
            error => {
              this.alertService.error('Error while retrieving Control Keys');
            });
          this.populateCsiGrid();
          // this.clearFormByType(this.getFormField('masterDataType').value);
          this.getFormField('controlTypeSelected').setValue('');
          this.getFormField('pcMilerVersion').setValue(null);
          this.getFormField('effectiveDate').setValue(null);
          this.getFormField('expiryDate').setValue(null);
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('There was an error deleting Control Keys');
        });
      }
    });
  }

  populateYears() {
    this.year = new Date().getFullYear();
    this.years.push(this.year);
    for (let i = 1; i < 6; i++) {
      this.years.push(this.year - i);
    }
  }

  saveFrtDieselPrice() {
    this.tmssLoader.show();
    this.showDieselPriceTable = false;
    this.frtDieselPriceEntity = new FrtDieselPrice();
    this.frtDieselPriceEntity.dieselPrice = +this.masterDataAdminForm.value.dollarsPerGallon;
    this.frtDieselPriceEntity.currentWeekMondayDate = this.masterDataAdminForm.value.entryDate;
    this.frtDieselPriceEntity.currentWeekWednesdayDate = null;
    this.frtDieselPriceEntity.nextWeekTuesdayDate = null;
    this.frtDieselPriceEntity.updateProgram = '';
    this.frtDieselPriceEntity.updateId = 0;
    this.frtDieselPriceEntity.updateDate = new Date();
    this.masterdataAdminService.saveFrtDieselPrice(this.frtDieselPriceEntity).subscribe(frtDieselPrice => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully inserted/Updated the Diesel Price');
        this.clearFormByType('Diesel Price');
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the Diesel Price ' + error);
      });
  }


  populateDieselPriceHistory() {
    this.showDieselPriceTable = true;
    const selectedYear = this.getFormField('year').value;
    this.masterdataAdminService.getDieselPriceHistory(selectedYear).subscribe(dieselPriceData => {
        this.dieselPriceDetails = dieselPriceData;
      },
      error => {
        this.alertService.error('Error while retrieving Diesel price for selected year');
      });

  }


  populateAgency() {
    this.loader.show();
    this.agencyMasterService.getAllAgency().subscribe(allAgencies => {
      this.agencyCustomerList = allAgencies;
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Agency User List');
    });
  }

  populateZones() {
    this.showZonesTable = true;
    this.loader.show();
    this.masterdataAdminService.getAllZones().subscribe(frtZones => {
      this.frtZones = frtZones;
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Agency Zones: ' + error);
    });
  }

  /**
   * @description when user selects the agency gets all the bureaus for the selectes agency
   * @param {string} agencyCodeValue
   */
  onCustomerNameChange(agencyCodeValue: string) {
    this.showCreateAgency = false;
    this.masterDataAdminForm.controls['bureauName'].setValue('');
    if (agencyCodeValue !== null) {
      this.agencyCode = agencyCodeValue;
      this.loader.show();
      this.agencyMasterService.getAllBureauByAgency(this.agencyCode).subscribe(allBureau => {
        this.agencyBureauList = allBureau;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Agency Bureau List: ' + error);
      });
    }
  }


  onBureauNameChange() {
    this.loader.show();
    this.zoneCodeList = [];
    this.zoneNameList = [];
    this.bureauCode = this.getFormField('bureauName').value;
    if (this.agencyCode != null && this.bureauCode != null) {
      this.showZonesTable = true;
      this.masterdataAdminService.getAgencyMasterByAgencyCodeAndBureauCode(this.agencyCode, this.bureauCode).subscribe(agencyMasterRecord => {
        this.agencyMaster = agencyMasterRecord;
        this.agencyMasterSelected = agencyMasterRecord;
        if (agencyMasterRecord != null) {
          this.masterdataAdminService.getZones(this.agencyMaster.agencyMasterId).subscribe(frtZones => {
            this.frtZones = frtZones;
            for (const frtZone of frtZones) {
              this.zoneCodeList.push(frtZone.zoneCode);
              this.zoneNameList.push(frtZone.zoneName);
            }
          });
          this.zoneCodeMinLengthToSearch = 1;
          this.zoneNameMaxCharLength = 20;
          this.zoneNameMinLengthToSearch = 2;
          this.zoneNameMaxCharLength = 45;
          this.zonecodetypeaheadlist = this.zoneCodeList;
          this.zonenametypeaheadlist = this.zoneNameList;
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Agency Bureau List: ' + error);
      });
    }
  }

  onZoneCodeClicked(selectedZoneCode) {
    this.clearFormByType('Zones');
    this.agencyMasterService.getDetailsByAgencyMasterId(selectedZoneCode.agencyMasterId).subscribe(agencyMasterDetails => {
      this.agencyMasterSelected = agencyMasterDetails;
      if (this.agencyMasterSelected !== null) {
        this.populateAgency();
        this.getFormField('agencyName').setValue(this.agencyMasterSelected.agencyCode);
        this.onCustomerNameChange(this.agencyMasterSelected.agencyCode);
        this.getFormField('bureauName').setValue(this.agencyMasterSelected.bureauCode);
      }
    });
    this.getFormField('zoneCode').setValue(selectedZoneCode.zoneCode);
    this.getFormField('zoneName').setValue(selectedZoneCode.zoneName);
    this.getFormField('city').setValue(selectedZoneCode.zoneCity);
    this.getFormField('state').setValue(selectedZoneCode.zoneState);
    this.getFormField('zip').setValue(selectedZoneCode.zoneZip);

  }

  resetFrtRatesZone() {
    this.clearFormByType('Zones');
  }

  saveFrtRatesZone() {
    this.tmssLoader.show();
    this.frtRatesZoneEntity = new FrtRatesZone();
    if (this.agencyMasterSelected !== null && this.agencyMasterSelected !== undefined) {
      this.frtRatesZoneEntity.agencyMasterId = this.agencyMasterSelected.agencyMasterId;
    }
    this.frtRatesZoneEntity.zoneCode = this.masterDataAdminForm.value.zoneCode;
    this.frtRatesZoneEntity.zoneName = this.masterDataAdminForm.value.zoneName;
    this.frtRatesZoneEntity.zoneState = this.masterDataAdminForm.value.state;
    this.frtRatesZoneEntity.zoneCity = this.masterDataAdminForm.value.city;
    this.frtRatesZoneEntity.zoneZip = this.masterDataAdminForm.value.zip;
    this.frtRatesZoneEntity.updateProgram = '';
    this.frtRatesZoneEntity.updateId = 0;
    this.frtRatesZoneEntity.updateDate = new Date();

    this.masterdataAdminService.saveFrtRatesZone(this.frtRatesZoneEntity).subscribe(frtRatesZone => {
        this.tmssLoader.hide();
        if (frtRatesZone != null) {
          this.stateCountryEntity = new StateCountry();
          // if (this.masterDataAdminForm.get('isUSA').value === true) {
          // if (this.isCountryUsa === true){
          // this.stateCountryEntity.stateCountryId = 326;
          // this.stateCountryEntity.parentCountryId = 326;
          // } else {
          this.stateCountryEntity.parentCountryId = frtRatesZone.frtRatesZoneId;
          this.stateCountryEntity.stateCountryId = frtRatesZone.frtRatesZoneId;
          // }
          this.stateCountryEntity.stateCountryType = 'Zone';
          this.stateCountryEntity.stateCountryCode = frtRatesZone.zoneCode;
          this.stateCountryEntity.stateCountryName = frtRatesZone.zoneCode;
          this.stateCountryEntity.stateCountryCode2Digit = '';
          this.stateCountryEntity.schedule = '';
          this.stateCountryEntity.serviceAreaId = 0;
          this.stateCountryEntity.contiguousUS = 0;
          this.stateCountryEntity.updateProgram = '';
          this.stateCountryEntity.updateId = 0;
          this.stateCountryEntity.frtRatesZoneId = frtRatesZone.frtRatesZoneId;
          this.stateCountryEntity.updateDate = new Date();
          this.stateCountryEntity.businessType = this.businessType;
          this.masterdataAdminService.saveorUpdateStateCountryByZone(this.stateCountryEntity).subscribe(stateCountry => {
          });
        }
        this.alertService.success('Successfully inserted/Updated the Zones');
        this.clearFormByType('Zones');
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the Zones ' + error);
      });
  }

  findCsiEffectiveAndExpiry() {
    this.tmssLoader.show();
    this.masterdataAdminService.getControlKeysByControlType('Customer Satisfaction Index')
      .subscribe(csiControlKeys => {
        this.csiRatePeriodDetails = csiControlKeys;
        (csiControlKeys as ControlKeys[]);
        csiControlKeys.forEach(csiControlKey => {
          csiControlKeys.effectiveDate = csiControlKey.effectiveDate;
          csiControlKeys.expiryDate = csiControlKey.expiryDate;
          csiControlKeys.controlId = csiControlKey.controlId;
          this.tmssLoader.hide();
        }, (error) => {
          this.alertService.error('Customer Satisfaction Index Rate Period Record did not get populated');
          this.tmssLoader.hide();
        });
      });
  }

  onCsiRatePeriodChange() {
    this.masterdataAdminService.getActiveCarriersByHHGOrHHGFRT().subscribe(csiActiveCarriers => {
        this.csiActiveCarriers = csiActiveCarriers;
        (csiActiveCarriers as Carrier[]);
        csiActiveCarriers.forEach(csiActiveCarrier => {
          csiActiveCarriers.scac = csiActiveCarrier.scac;
        });
      },
      error => {
        this.alertService.error('Error while retrieving active carriers');
      });
    this.populateCsiGrid();

  }


  populateCsiGrid() {
    this.tmssLoader.show();
    const selectedCsiRatePeriod = this.getFormField('csiRatePeriod').value;
    this.showCsiTable = true;
    this.isSelected = false;
    this.csiCarrier = new Carrier();
    this.masterdataAdminService.getHhgCsiByControlId(+selectedCsiRatePeriod).subscribe(hhgCsi => {
        this.tmssLoader.hide();
        this.csiDetails = hhgCsi;
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while retrieving Customer Satisfactin index');
      });

  }

  findControlIdBySelectedCsiRatePeriod() {
    this.tmssLoader.show();
    const selectedCsiRatePeriod = this.getFormField('csiRatePeriod').value;
    this.masterdataAdminService.getHhgCsiByControlId(+selectedCsiRatePeriod).subscribe(hhgCsi => {
        this.tmssLoader.hide();
        this.csiDetails = hhgCsi;
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while retrieving Customer Satisfactin index');
      });
  }


  onCarrierIdClick(selectedCarrierId) {
    /*this.tmssLoader.show();
    this.masterdataAdminService.getCarrierByCarrierIdTsp(selectedCarrierId.carrierId).subscribe(carrier => {
        this.tmssLoader.hide();
    this.getFormField('csiScac').setValue(carrier.scac);
     },
    error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while retrieving Carrier Scac');
    });*/
    this.getFormField('csiScac').setValue(selectedCarrierId.scac);
    this.getFormField('csiDomestic').setValue(selectedCarrierId.domesticCsi);
    this.getFormField('csiInternational').setValue(selectedCarrierId.internationalCsi);
    this.isSelected = true;
    this.hhgCsiEntity = new HhgCustomerSatisfactionIndex();
    this.hhgCsiEntity.hhgCsiId = selectedCarrierId.hhgCsiId;
    this.hhgCsiEntity.carrierId = selectedCarrierId.carrierId;
    this.hhgCsiEntity.controlId = selectedCarrierId.controlId;
    this.hhgCsiEntity.domesticCsi = selectedCarrierId.domesticCsi;
    this.hhgCsiEntity.internationalCsi = selectedCarrierId.internationalCsi;
    this.hhgCsiEntity.dosInternationalCsi = selectedCarrierId.dosInternationalCsi;
    this.hhgCsiEntity.updateProgram = selectedCarrierId.updateProgram;
    this.hhgCsiEntity.updateId = selectedCarrierId.updateId;
    this.hhgCsiEntity.updateDate = selectedCarrierId.updateDate;
    this.hhgCsiEntity.scac = selectedCarrierId.scac;


  }

  onReset() {
    this.getFormField('csiScac').setValue('');
    this.getFormField('csiDomestic').setValue('');
    this.getFormField('csiInternational').setValue('');
    this.isSelected = false;
  }

  saveOrUpdateHhgCsi() {
    this.tmssLoader.show();
    this.hhgCsiId = 0;
    this.carrierId = 0;
    let createFlag = true;
    const scac = this.getFormField('csiScac').value;
    this.csiDetails.forEach(element => {
      if (element.scac == scac) {
        createFlag = false;
        this.hhgCsiId = element.hhgCsiId;
        this.carrierId = element.carrierId;
        this.hhgCsiEntity = element;
      }
    });

    if (createFlag) {
      this.createHhgCsi();
      return;
    }

    this.hhgCsiEntity.hhgCsiId = this.hhgCsiId;
    this.hhgCsiEntity.carrierId = this.carrierId;
    this.hhgCsiEntity.domesticCsi = this.masterDataAdminForm.value.csiDomestic ? this.masterDataAdminForm.value.csiDomestic : 0;
    this.hhgCsiEntity.internationalCsi = this.masterDataAdminForm.value.csiInternational ? this.masterDataAdminForm.value.csiInternational : 0;
    this.hhgCsiEntity.dosInternationalCsi = 0.00;
    this.hhgCsiEntity.dosDomesticCsi = 0.00;
    this.hhgCsiEntity.updateProgram = '';
    this.hhgCsiEntity.updateId = 0;
    this.hhgCsiEntity.updateDate = new Date();
    this.masterdataAdminService.saveorUpdateHhgCsiRecord(this.hhgCsiEntity).subscribe(hhgCsiEntity => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully inserted/Updated the Customer Satisfaction Index');
        this.populateCsiGrid();
        this.clearFormByType('Customer Satisfaction Index');
        this.onReset();
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the Customer Satisfaction Index' + error);
      });
  }

  createHhgCsi() {
    // this.tmssLoader.show();
    this.hhgCsiEntity = new HhgCustomerSatisfactionIndex();
    const scac = this.getFormField('csiScac').value;
    const selectedCsiRatePeriod = this.getFormField('csiRatePeriod').value;
    // this.hhgCsiEntity.hhgCsiId = 0;
    this.hhgCsiEntity.carrierId = 0;
    this.hhgCsiEntity.controlId = selectedCsiRatePeriod;
    this.hhgCsiEntity.domesticCsi = this.masterDataAdminForm.value.csiDomestic;
    this.hhgCsiEntity.internationalCsi = this.masterDataAdminForm.value.csiInternational;
    this.hhgCsiEntity.dosInternationalCsi = 0.00;
    this.hhgCsiEntity.dosDomesticCsi = 0.00;
    this.hhgCsiEntity.updateProgram = '';
    this.hhgCsiEntity.updateId = 0;
    this.hhgCsiEntity.updateDate = new Date();
    this.hhgCsiEntity.scac = scac;

    this.masterdataAdminService.saveorUpdateHhgCsiRecord(this.hhgCsiEntity).subscribe(hhgCsiEntity => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully inserted/Updated the Customer Satisfaction Index');
        this.populateCsiGrid();
        this.clearFormByType('Customer Satisfaction Index');
        this.onReset();
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving/updating the Customer Satisfaction Index' + error);
      });

  }


  deleteHhgCsi() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this Customer Satisifaction Index';
    this.modalRef.content.title = 'Deleting Customer Satisfaction';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.masterdataAdminService.deleteHhgCsiRecord(this.hhgCsiEntity).subscribe(() => {
          this.tmssLoader.hide();
          this.alertService.success('Successfully Deleted Customer Satisfaction Index');
          this.populateCsiGrid();
          this.clearFormByType(this.getFormField('masterDataType').value);
          this.onReset();
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('There was an error deleting Customer Satisfaction Index');
        });
      }
    });
  }

  // This function is used to clear all the form values based on master data admin type
  // Drop down master data admin type will remain same.
  clearFormByType(masterDateAdminType: string) {
    if (masterDateAdminType === MDT.COUNTRY) {
      this.getFormField('countryCode').setValue(null);
      this.getFormField('countryName').setValue(null);
    } else if (masterDateAdminType === MDT.SERVICEAREA) {
      this.getFormField('serviceAreaCode').setValue(null);
      this.getFormField('description').setValue(null);
    } else if (masterDateAdminType === MDT.COUNTY) {
      this.getFormField('countyName').setValue(null);
      this.getFormField('stateAbbreviation').setValue(null);
      this.getFormField('countyCode').setValue(null);
      this.getFormField('iccId').setValue(null);
      this.getFormField('gsaServiceArea').setValue(null);
    } else if (masterDateAdminType === MDT.FREIGHTSERVICESMASTER) {
      this.getFormField('ratePeriod').setValue(null);
      this.getFormField('freightRateType').setValue(null);
      this.getFormField('sroId').setValue(null);
      if (this.showltl) {
        this.getFormField('ltlMinimumPct').setValue(null);
        this.getFormField('ltlMaximumPct').setValue(null);
      } else if (this.showtl) {
        this.getFormField('tlMinimumPct').setValue(null);
        this.getFormField('tlMaximumPct').setValue(null);
      }
    } else if (masterDateAdminType === MDT.CARRIERRFSPS) {
      this.getFormField('carrierIdRfsp').setValue(null);
      this.getFormField('carrierIdTsp').setValue(null);
      this.getFormField('shipmentType').setValue(null);
    } else if (masterDateAdminType === MDT.CONTROLKEYS) {
      this.getFormField('controlTypeSelected').setValue('');
      this.getFormField('pcMilerVersion').setValue(null);
      this.getFormField('effectiveDate').setValue(null);
      this.getFormField('expiryDate').setValue(null);
    } else if (masterDateAdminType === MDT.DIESELPRICE) {
      this.getFormField('dollarsPerGallon').setValue('');
      this.getFormField('entryDate').setValue(null);
    } else if (masterDateAdminType === MDT.ZONES) {
      this.getFormField('agencyName').setValue('');
      this.getFormField('bureauName').setValue('');
      this.getFormField('zoneCode').setValue(null);
      this.getFormField('zoneName').setValue(null);
      this.getFormField('city').setValue(null);
      this.getFormField('state').setValue(null);
      this.getFormField('zip').setValue(null);
    } else if (masterDateAdminType === MDT.CUSTOMERSATISFACTIONINDEX) {
      this.getFormField('csiSac').setValue('');
      this.getFormField('csiDomestic').setValue(null);
      this.getFormField('csiInternational').setValue(null);
    }
  }

  // This function is used to clear all the form values & set them to default
  clearForm() {
    this.masterDataAdminForm.reset();
  }

  /*
* Populating Country in the drop down list
*/
  getCountryList() {
    this.tmssLoader.show();
    const countryList = [];
    this.stateCountryType = 'Country';
    this.customerRegistrationService.getAllStates(this.stateCountryType).subscribe(
      countries => {
        this.countryList = countries;
        this.tmssLoader.hide();
        return this.countryList;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Country drop down did not get populated');
      });
  }

  /**
   * @description listens to sountry changes and enables/disabels the controls.
   */
  onCountryChange() {
    this.masterDataAdminForm.get('zip').setValue(null);
    this.masterDataAdminForm.get('state').setValue(null);
    this.masterDataAdminForm.get('city').setValue(null);
    const country = this.masterDataAdminForm.get('country').value;
    if (country !== '326') {
      this.isCountryUsa = false;
      this.masterDataAdminForm.get('state').disable();
      this.masterDataAdminForm.get('zip').disable();
      this.masterDataAdminForm.get('state').clearValidators();
      this.masterDataAdminForm.get('zip').clearValidators();
    } else {
      this.isCountryUsa = true;
      this.masterDataAdminForm.get('state').enable();
      this.masterDataAdminForm.get('zip').enable();
      this.masterDataAdminForm.get('state').setValidators([Validators.required]);
      this.masterDataAdminForm.get('zip').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(5)]);
    }
  }

  viewAuditTrailCountry() {
    if (this.showCountryFields) { // display audit trail for Country
      // this.viewAuditTrialForCountry();
    }
  }

  viewAuditTrialForCountry() {
    this.loader.show();
    const profileName = 'Master Data Admin - Country';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-Country').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  viewAuditControlType() {
    this.loader.show();
    const profileName = 'Master Data Admin - Control Type';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-ControlType').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  viewAuditTrialForServiceArea() {
    this.loader.show();
    const profileName = 'Master Data Admin - Service Area';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-ServiceArea').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  // MasterDataAdmin-County
  viewAuditTrialForCounty() {
    this.loader.show();
    const profileName = 'Master Data Admin - County';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-County').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  // MasterDataAdmin-County
  viewAuditTrialForRFSP() {
    this.loader.show();
    const profileName = 'Master Data Admin - Rate Service';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-RateService').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  viewAuditTrialForDieselPrice() {
    this.loader.show();
    const profileName = 'Master Data Admin - Diesel Price';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-DieselPrice').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }
  viewAuditTrailZone() {
    this.loader.show();
    const profileName = 'Master Data Admin - Zone';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-Zone').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  deleteTspCoreNotifications() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete the Selected Agency Group(s)?';
    this.modalRef.content.title = 'Deleting Agency Groups(s)';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        const selectedRows = this.gridOptionsApi.getSelectedRows();
        console.log(selectedRows);
        if (selectedRows && selectedRows.length > 0) {
          const payload = selectedRows.reduce((acc, item) =>{
            if (Array.isArray(item.agencyTspCoreNotificationId)) {
              const parseids = item.agencyTspCoreNotificationId.map(id => parseInt(id, 10));
              return acc.concat(parseids);
            }
          }, []);
          console.log(payload);
          this.masterdataAdminService.deleteAgencyTspCoreNotifications(payload).subscribe(res => {
              this.loader.hide();
            this.populateAgencyTspCoreNotifications();
            this.alertService.success("The Agency Groups(s) have been successfully deleted.")
          }, error => {
              this.loader.hide();
              this.alertService.error("An error occurred while deleting agency group(s).")
          })
        }
      }
    });
  }

  moveItems() {
    const sourceArray = this.coreTspForm.get('appCarriers').value;
    const appCarriers = [];
    const destinationArray = AppConstants.isNotNullCondition(this.assignedCarriers) ? this.assignedCarriers : [];
    this.carrierList.forEach(e => {
      sourceArray.forEach(y => {
        const isPresent = destinationArray.find(x => x.carrierId === y.carrierId);
        if (e.carrierId === y.carrierId && !isPresent) {
          appCarriers.push(e);
        }
      });
    });
    this.assignedCarriers = Array.from(new Set(destinationArray.concat(appCarriers)));
  }

  handleRateTypesMultiDropdown(i: any) {
    this.assignedCarriers.splice(i, 1);
  }

  viewAuditTrailCustomerSatisfactionIndex(){
    this.loader.show();
    const profileName = 'MasterDataAdmin - Customer Satisfaction Index';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-CIX').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }
  viewAuditAgencyGroup(){
    this.loader.show();
    const profileName = 'MasterDataAdmin - Core TSP Notification';
    this.shipmentAuditTrailService.getAuditTrailListByUpdateProgram('MasterDataAdmin-CN').subscribe(data => {
      if (data) {
        const auditTrailLogList = data;
        const initialState: any = {
          auditTrailLogList: auditTrailLogList,
          profile: profileName
        };
        this.modalRef = this.modalService.show(MasterDataAdminCountryAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

}
